import React, { Component } from "react";
import { Form, Message, Table, Input, Header, Segment, Icon, Button, Divider, Modal } from "semantic-ui-react";
import { formatCurrency } from "../../utils/constants";
import request from "../../utils/request";
import { AppContext } from "../../utils/context";
import _ from "lodash";

class EventCashDrops extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      eventId: this.props.match.params.id,
      formLoading: false,
      isMounted: false,
      xhrMessage: "",
      xhrStatus: "",
      cashDropId: 0,
      volunteerOptions: [],
      volunteerId: 0,
      count_1: 0,
      count_2: 0,
      count_5: 0,
      count_10: 0,
      count_20: 0,
      count_50: 0,
      count_100: 0,
      total: 0,
      cashDropsResponse: [],
      cashDropsByVolunteer: [],
      totalCashOnHand: 0,
      totalSales:0,
      totalCashSales: 0,
      totalCashDrops: 0,
      cashFloat: 0,
      isModalOpen: false,
      currency: context.config && context.config.currency ? context.config.currency : "USD"
    };
    this.fetchSellers = this.fetchSellers.bind(this);
    this.fetchCashDrops = this.fetchCashDrops.bind(this);
    this.fetchCashDropsCallback = this.fetchCashDropsCallback.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCashOnHand = this.handleCashOnHand.bind(this);
  }
  componentDidMount = () => {
    this.fetchSellers();
    this.fetchCashDrops();
  };
  componentDidUpdate = (prevProps, prevState) => {
    // Typical usage (don't forget to compare props):
    if (this.props.eventId !== prevProps.eventId) {
      this.setState({
        formLoading: true,
        eventId: this.props.eventId
      });
    }
    if (this.state.volunteerId !== prevState.volunteerId) {
      this.handleCashOnHand();
    }
    if (this.state.mode !== prevState.mode) {
      this.resetCashDrop();
    }
    if (this.state.cashDropsResponse.cashDrops && prevState.cashDropsResponse.cashDrops) {
      if (_.isEqual(this.state.cashDropsResponse.cashDrops[+this.state.volunteerId], prevState.cashDropsResponse.cashDrops[+prevState.volunteerId]) !== true) {
        this.fetchSellers();
      }
    }
  };
  resetCashDrop = () => {
    this.setState({
      formLoading: false,
      cashDropId: 0,
      count_1: 0,
      count_2: 0,
      count_5: 0,
      count_10: 0,
      count_20: 0,
      count_50: 0,
      count_100: 0,
      total: 0,
      isModalOpen: false
    });
  }
  handleChange = (e, { name, value }) => {
    if (name.indexOf("mode") >= 0) {
      value = value === 1 ? "dynamic" : "manual";
    }
    this.setState({ [name]: value });
  }
  handleInputChange = (e, { name, value }) => {
    this.setState({ [name]: value }, function () {
      let denominationTotal =
        Number(this.state.count_1 * 1) +
        Number(this.state.count_5 * 5) +
        Number(this.state.count_10 * 10) +
        Number(this.state.count_20 * 20) +
        Number(this.state.count_50 * 50) +
        Number(this.state.count_100 * 100);
      if (this.state.currency === "CAD" || this.state.currency === "cad") {
        denominationTotal += Number(this.state.count_2 * 2);
      }
      this.setState({ total: denominationTotal });
    });
  }
  handleSubmit = (cashDropsTotal) => {
    this.setState({ formLoading: true });
    var cashDropPayload = {
      cashdrop_id: this.state.cashDropId ? this.state.cashDropId : 0,
      event_id: this.state.eventId,
      volunteer_id: this.state.volunteerId ? this.state.volunteerId : 0,
      count1: Number(this.state.count_1),
      count2: Number(this.state.count_2),
      count5: Number(this.state.count_5),
      count10: Number(this.state.count_10),
      count20: Number(this.state.count_20),
      count50: Number(this.state.count_50),
      count100: Number(this.state.count_100),
      total: cashDropsTotal
    };
    if (+this.state.cashDropId > 0) {
      return request.put(this, "api:/event/cashdrop", cashDropPayload).then(resp => {
        let initialResp = {
          cashDropId: resp.cashDropId,
          xhrStatus: resp.status,
          xhrMessage: resp.errorMessage ? resp.errorMessage : (resp.status === "success" ? `Cash drop with id ${resp.cashDropId} successfully updated` : resp.message)
        }
        this.fetchCashDropsCallback(initialResp);
      });
    } else {
      return request.post(this, "api:/event/cashdrop", cashDropPayload).then(resp => {
        let initialResp = {
          cashDropId: resp.cashDropId,
          xhrStatus: resp.status,
          xhrMessage: resp.errorMessage ? resp.errorMessage : (resp.status === "success" ? `Cash drop with id ${resp.cashDropId} successfully added` : resp.message)
        }
        this.fetchCashDropsCallback(initialResp);
      });
    }
  };
  startLoading = () => {
    this.setState({ formLoading: true });
  }
  doneLoading = () => {
    this.setState({ formLoading: false });
  }
  handleCashOnHand = () => {
    this.state.volunteerOptions.forEach(element => {
      if (element.value === this.state.volunteerId) this.setState({
        totalSales: element.totalsales,
        totalCashOnHand: element.totalcashonhand,
        totalCashSales: element.totalcashsales,
        totalCashDrops: element.totalcashdrops,
        cashFloat: element.cashfloat,
        cashDropsByVolunteer: this.state.cashDropsResponse.cashDrops[this.state.volunteerId]
      }, () => this.resetCashDrop());
    });
  }
  fetchSellers = () => {
    this.startLoading();
    request.get(this, `api:/event-sellers/${this.state.eventId}&ts=${Date.now()}`).then(resp => {
      let sellers = [];
      resp && resp.data && resp.data.map((value) => {
        if ((value.volunteer_id !== 50000 && !value.web_sales)
          && (value.volunteer_id !== 0 && value.login !== "ALL RSUs")) {
          sellers.push({
            text: value.volunteer,
            value: value.volunteer_id,
            totalsales: formatCurrency(value.total, this.context.config.language),
            totalcashonhand: formatCurrency(value.cash_on_hand, this.context.config.language),
            totalcashsales: formatCurrency(value.salesamount_cash, this.context.config.language),
            totalcashdrops: formatCurrency(value.cash_drops, this.context.config.language),
            cashfloat: formatCurrency(value.cash_float, this.context.config.language)
          });
        }
        return false;
      });
      this.setState({ volunteerOptions: sellers }, () => this.handleCashOnHand());
      return true;
    });
  };
  fetchCashDrops = () => {
    this.startLoading();
    request.get(this, `api:/event/cashdrop/?event_id=${this.state.eventId}`).then(resp => {
      this.setState({ cashDropsResponse: resp }, () => this.doneLoading());
    });
  };
  fetchCashDropsCallback = (initialResp) => {
    this.startLoading();
    request.get(this, `api:/event/cashdrop/?event_id=${this.state.eventId}&ts=${Date.now()}`).then(resp => {
      this.setState({
        cashDropsResponse: resp,
        formLoading: false,
        cashDropId: initialResp.cashDropId ? initialResp.cashDropId : 0,
        xhrStatus: initialResp.xhrStatus,
        xhrMessage: initialResp.xhrMessage
      });
    });
  }
  handleEditIcon = (cashDropRow) => {
    this.setState({
      isModalOpen: true,
      cashDropId: cashDropRow['id'],
      count_1: cashDropRow['count_1'],
      count_2: cashDropRow['count_2'],
      count_5: cashDropRow['count_5'],
      count_10: cashDropRow['count_10'],
      count_20: cashDropRow['count_20'],
      count_50: cashDropRow['count_50'],
      count_100: cashDropRow['count_100'],
      total: cashDropRow['total']
    });
  }
  handleUpdate = () => {
    this.setState({ formLoading: true, isModalOpen: false });
    var cashDropPayload = {
      cashdrop_id: this.state.cashDropId ? this.state.cashDropId : 0,
      event_id: this.state.eventId,
      volunteer_id: this.state.volunteerId ? this.state.volunteerId : 0,
      count1: Number(this.state.count_1),
      count2: this.state.count_2 ? Number(this.state.count_2) : 0,
      count5: Number(this.state.count_5),
      count10: Number(this.state.count_10),
      count20: Number(this.state.count_20),
      count50: Number(this.state.count_50),
      count100: Number(this.state.count_100),
      total: this.state.total
    };
    return request.put(this, `api:/event/cashdrop/${this.state.cashDropId}`, cashDropPayload).then(resp => {
      let initialResp = {
        cashDropId: resp.cashDropId,
        xhrStatus: resp.status,
        xhrMessage: resp.errorMessage ? resp.errorMessage : (resp.status === "success" ? `Cash drop with id ${resp.cashDropId} successfully updated` : resp.message)
      }
      this.fetchCashDropsCallback(initialResp);
    });
  }
  handleDelete = (cashDropId) => {
    this.startLoading();
    request.delete(this, `api:/event/cashdrop/${cashDropId}`).then(resp => {
      let initialResp = {
        xhrStatus: resp.status,
        xhrMessage: resp.status === "success" ? "Cash drop successfully deleted" : "Error trying to delete cash drop",
      }
      this.fetchCashDropsCallback(initialResp);
    });
  }
  render() {
    const {
      formLoading,
      xhrMessage,
      xhrStatus,
      volunteerOptions,
      count_1,
      count_2,
      count_5,
      count_10,
      count_20,
      count_50,
      count_100,
      total,
      cashDropsByVolunteer,
      totalSales,
      totalCashOnHand,
      totalCashSales,
      totalCashDrops,
      cashFloat,
      isModalOpen
    } = this.state;

    const { config } = this.context;
    let denominationTotal = Number(count_1 * 1) +
      Number(count_2 * 2) +
      Number(count_5 * 5) +
      Number(count_10 * 10) +
      Number(count_20 * 20) +
      Number(count_50 * 50) +
      Number(count_100 * 100);
    let cashDropsTotal = denominationTotal > 0 ? denominationTotal : total;
    if (cashDropsByVolunteer && (this.state.currency === "USD" || this.state.currency === "usd")) {
      cashDropsByVolunteer.filter(function (el) {
        delete el['count_2'];
        return el && el != null;
      });
    }
    const editDropStyle = { maxWidth: "20px" };
    const editDropInputStyle = { display: "block", minWidth: "20px" };
    return (
      <Form
        id="cashDropForm"
        loading={formLoading}
        success={xhrStatus === "success"}
        error={xhrStatus === "fail"}
        onSubmit={() => this.handleSubmit(cashDropsTotal)}
      >
        <Message success content={xhrMessage} />
        <Message error content={xhrMessage} />
        <Form.Group inline>
          <label>Choose a Seller</label>
          <Form.Select options={volunteerOptions} name="volunteerId" onChange={this.handleChange} />
          {+this.state.volunteerId > 0 && <>
            <label>Total Sales: <span style={{ "fontSize": "18px" }}>{totalSales}</span></label>
            <label>Total Cash Sales: <span style={{ "fontSize": "18px" }}>{totalCashSales}</span></label>
            <label>Total Cash Drops: <span style={{ "fontSize": "18px" }}>{totalCashDrops}</span></label>
            <label>Total Cash On Hand: <span style={{ "fontSize": "18px" }}>{totalCashOnHand}</span></label>
            <label>Cash Float: <span style={{ "fontSize": "18px" }}>{cashFloat}</span></label>
          </>}
        </Form.Group>
        {+this.state.volunteerId > 0 && cashDropsByVolunteer &&
          <Segment color="blue">
            {Object.keys(cashDropsByVolunteer).length > 0 && <Header>Previous cash drops by this seller for the event</Header>}
            {Object.keys(cashDropsByVolunteer).length > 0 &&
              <Table celled compact definition striped size="small">
                <Table.Header fullWidth>
                  <Table.Row textAlign='center'>
                    <Table.HeaderCell />
                    <Table.HeaderCell collapsing>Cash Drop Id</Table.HeaderCell>
                    <Table.HeaderCell>Date</Table.HeaderCell>
                    <Table.HeaderCell>x {formatCurrency(1, config.language)}</Table.HeaderCell>
                {(this.state.currency === "CAD" || this.state.currency === "cad") &&<Table.HeaderCell>x {formatCurrency(2, config.language)}</Table.HeaderCell>}
                    <Table.HeaderCell>x {formatCurrency(5, config.language)}</Table.HeaderCell>
                    <Table.HeaderCell>x {formatCurrency(10, config.language)}</Table.HeaderCell>
                    <Table.HeaderCell>x {formatCurrency(20, config.language)}</Table.HeaderCell>
                    <Table.HeaderCell>x {formatCurrency(50, config.language)}</Table.HeaderCell>
                    <Table.HeaderCell>x {formatCurrency(100, config.language)}</Table.HeaderCell>
                    <Table.HeaderCell>Total</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {Object.keys(cashDropsByVolunteer).map((v, k) => {
                    return (<Table.Row textAlign='center' key={v}>
                      <Table.Cell collapsing>
                        <Button.Group>
                          <Modal
                            closeIcon
                            open={isModalOpen}
                            trigger={<Button
                              type="button"
                              icon
                              onClick={() => this.handleEditIcon(cashDropsByVolunteer[k])}
                            >
                              <Icon name="edit" color="blue" />
                            </Button>}
                            onClose={() => this.resetCashDrop()}
                          >
                            <Header icon='edit' content='Update cash drop' />
                            <Modal.Content scrolling>
                              <Table celled compact definition size="small">
                                  <Table.Header fullWidth>
                                    <Table.Row textAlign='center'>
                                    <Table.HeaderCell style={editDropStyle} />
                                    <Table.HeaderCell style={{ maxWidth: "5px" }}>x {formatCurrency(1, config.language)}</Table.HeaderCell>
                                    {(this.state.currency === "CAD" || this.state.currency === "cad") && <Table.HeaderCell style={editDropStyle}>x {formatCurrency(2, config.language)}</Table.HeaderCell>}
                                    <Table.HeaderCell style={editDropStyle}>x {formatCurrency(5, config.language)}</Table.HeaderCell>
                                    <Table.HeaderCell style={editDropStyle}>x {formatCurrency(10, config.language)}</Table.HeaderCell>
                                    <Table.HeaderCell style={editDropStyle}>x {formatCurrency(20, config.language)}</Table.HeaderCell>
                                    <Table.HeaderCell style={editDropStyle}>x {formatCurrency(50, config.language)}</Table.HeaderCell>
                                    <Table.HeaderCell style={editDropStyle}>x {formatCurrency(100, config.language)}</Table.HeaderCell>
                                    <Table.HeaderCell style={editDropStyle}>Total</Table.HeaderCell>
                                    </Table.Row>
                                  </Table.Header>
                                  <Table.Body>
                                    <Table.Row textAlign='center'>
                                    <Table.Cell style={editDropStyle}>Count</Table.Cell>
                                    <Table.Cell style={editDropStyle}><Input style={editDropInputStyle} type="text" min="0" onChange={this.handleInputChange} name="count_1" value={this.state.count_1} /></Table.Cell>
                                    {(this.state.currency === "CAD" || this.state.currency === "cad") && <Table.Cell style={editDropStyle}><Input style={editDropInputStyle} type="text" min="0" onChange={this.handleInputChange} name="count_2" value={this.state.count_2} /></Table.Cell>}
                                    <Table.Cell style={editDropStyle}><Input style={editDropInputStyle} type="text" min="0" onChange={this.handleInputChange} name="count_5" value={this.state.count_5} /></Table.Cell>
                                    <Table.Cell style={editDropStyle}><Input style={editDropInputStyle} type="text" min="0" onChange={this.handleInputChange} name="count_10" value={this.state.count_10} /></Table.Cell>
                                    <Table.Cell style={editDropStyle}><Input style={editDropInputStyle} type="text" min="0" onChange={this.handleInputChange} name="count_20" value={this.state.count_20} /></Table.Cell>
                                    <Table.Cell style={editDropStyle}><Input style={editDropInputStyle} type="text" min="0" onChange={this.handleInputChange} name="count_50" value={this.state.count_50} /></Table.Cell>
                                    <Table.Cell style={editDropStyle}><Input style={editDropInputStyle} type="text" min="0" onChange={this.handleInputChange} name="count_100" value={this.state.count_100} /></Table.Cell>
                                    <Table.Cell style={editDropStyle}><Input style={editDropInputStyle} type="text" min="0" onChange={this.handleChange} name="total" value={this.state.total} /></Table.Cell>
                                    </Table.Row>
                                  </Table.Body>
                                </Table>
                            </Modal.Content>
                            <Modal.Actions>
                              <Form.Button
                                type="button"
                                primary
                                content='Save'
                                icon='save'
                                onClick={() => this.handleUpdate()}
                              />
                            </Modal.Actions>
                          </Modal>
                          <Button type="button" icon onClick={() => this.handleDelete(cashDropsByVolunteer[k].id)}>
                            <Icon name="trash" color="red" />
                          </Button>
                        </Button.Group>
                      </Table.Cell>
                      <Table.Cell>{cashDropsByVolunteer[k].id}</Table.Cell>
                      <Table.Cell>{cashDropsByVolunteer[k].created_at}</Table.Cell>
                      <Table.Cell>{cashDropsByVolunteer[k].count_1}</Table.Cell>
                      {(this.state.currency === "CAD" || this.state.currency === "cad") && <Table.Cell>{cashDropsByVolunteer[k].count_2}</Table.Cell>}
                      <Table.Cell>{cashDropsByVolunteer[k].count_5}</Table.Cell>
                      <Table.Cell>{cashDropsByVolunteer[k].count_10}</Table.Cell>
                      <Table.Cell>{cashDropsByVolunteer[k].count_20}</Table.Cell>
                      <Table.Cell>{cashDropsByVolunteer[k].count_50}</Table.Cell>
                      <Table.Cell>{cashDropsByVolunteer[k].count_100}</Table.Cell>
                      <Table.Cell>{cashDropsByVolunteer[k].total}</Table.Cell>
                    </Table.Row>)
                  })}
                </Table.Body>
              </Table>
            }
          </Segment>
        }
        {+this.state.volunteerId > 0 && cashDropsByVolunteer && <Divider horizontal>OR</Divider>}
        {+this.state.volunteerId > 0 &&
          <Form.Group>
            {this.state.mode === "manual" ? (
              <Input type="number" min="0" label="$" onChange={this.handleChange} name="total" value={cashDropsTotal} />
            ) : (
              <Segment color="green">
                <Header>Add a cash drop</Header>
                <Table celled compact definition collapsing striped size="small">
                  <Table.Header fullWidth>
                    <Table.Row textAlign='center'>
                      <Table.HeaderCell>Denomination</Table.HeaderCell>
                      <Table.HeaderCell>x {formatCurrency(1, config.language)}</Table.HeaderCell>
                      {(this.state.currency === "CAD" || this.state.currency === "cad") && <Table.HeaderCell>x {formatCurrency(2, config.language)}</Table.HeaderCell>}
                      <Table.HeaderCell>x {formatCurrency(5, config.language)}</Table.HeaderCell>
                      <Table.HeaderCell>x {formatCurrency(10, config.language)}</Table.HeaderCell>
                      <Table.HeaderCell>x {formatCurrency(20, config.language)}</Table.HeaderCell>
                      <Table.HeaderCell>x {formatCurrency(50, config.language)}</Table.HeaderCell>
                      <Table.HeaderCell>x {formatCurrency(100, config.language)}</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    <Table.Row textAlign='center'>
                      <Table.Cell>Count</Table.Cell>
                      <Table.Cell><Input type="number" min="0" onChange={this.handleChange} name="count_1" value={this.state.count_1} /></Table.Cell>
                      {(this.state.currency === "CAD" || this.state.currency === "cad") && <Table.Cell><Input type="number" min="0" onChange={this.handleChange} name="count_2" value={this.state.count_2} /></Table.Cell>}
                      <Table.Cell><Input type="number" min="0" onChange={this.handleChange} name="count_5" value={this.state.count_5} /></Table.Cell>
                      <Table.Cell><Input type="number" min="0" onChange={this.handleChange} name="count_10" value={this.state.count_10} /></Table.Cell>
                      <Table.Cell><Input type="number" min="0" onChange={this.handleChange} name="count_20" value={this.state.count_20} /></Table.Cell>
                      <Table.Cell><Input type="number" min="0" onChange={this.handleChange} name="count_50" value={this.state.count_50} /></Table.Cell>
                      <Table.Cell><Input type="number" min="0" onChange={this.handleChange} name="count_100" value={this.state.count_100} /></Table.Cell>
                    </Table.Row>
                    <Table.Row textAlign='center'>
                      <Table.Cell>Total</Table.Cell>
                      <Table.Cell>{formatCurrency(+this.state.count_1* 1, config.language)}</Table.Cell>
                      {(this.state.currency === "CAD" || this.state.currency === "cad") && <Table.Cell>{formatCurrency(+this.state.count_2 * 2, config.language)}</Table.Cell>}
                      <Table.Cell>{formatCurrency(+this.state.count_5 * 5, config.language)}</Table.Cell>
                      <Table.Cell>{formatCurrency(+this.state.count_10* 10, config.language)}</Table.Cell>
                      <Table.Cell>{formatCurrency(+this.state.count_20* 20, config.language)}</Table.Cell>
                      <Table.Cell>{formatCurrency(+this.state.count_50* 50, config.language)}</Table.Cell>
                      <Table.Cell>{formatCurrency(+this.state.count_100* 100, config.language)}</Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table></Segment>
            )}
          </Form.Group>
        }
        {+this.state.volunteerId > 0 &&
          <Form.Radio
            toggle
            name="mode"
            value={this.state.mode === "manual" ? 1 : 0}
            defaultChecked={this.state.mode === "manual" ? true : false}
            label={this.state.mode === "manual" ? "Turn OFF the toggle to enter denominations" : "Turn ON to explicitly set the cash drop amount"}
            onChange={this.handleChange}
            className="radioToggleBtn"
          />
        }
        {+this.state.volunteerId > 0 &&
          <Form.Group inline>
            <Form.Button
              primary
              content='Save'
              icon='save'
            />
            <Form.Button
              type="button"
              onClick={this.resetCashDrop}
              accent="true"
              content='Reset'
              icon='refresh'
            />
          </Form.Group>
        }
      </Form>
    );
  }
}

EventCashDrops.contextType = AppContext;

export default EventCashDrops;
